import { render, staticRenderFns } from "./TDraftEdit.vue?vue&type=template&id=6c678660&"
import script from "./TDraftEdit.vue?vue&type=script&lang=js&"
export * from "./TDraftEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c678660')) {
      api.createRecord('6c678660', component.options)
    } else {
      api.reload('6c678660', component.options)
    }
    module.hot.accept("./TDraftEdit.vue?vue&type=template&id=6c678660&", function () {
      api.rerender('6c678660', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/services/directDebit/TDraftEdit.vue"
export default component.exports